export const BILL_SETTINGS_ENDPOINTS = {
  GET_APPROVAL_STAGE_USERS: (stageId: string, projectIds: string) =>
    `/bills/settings/approval-stage/${stageId}/users/?project_ids=${projectIds}`,
};

// Bills
export const BILLS_ENDPOINTS = {
  // GET
  GET_BILLS: '/bills/list/',
  /** Single bill fetch (POST path for detail: flat `{ id, project_ids?, … }`) */
  GET_BILL: '/bills/get',
  GET_BILL_SETTINGS: '/bills/settings/get/',
  GET_PREVIOUS_BILLS: '/bills/previous_bills/',
  // POST
  CREATE_BILL: '/bills/create/',
  CREATE_BILL_SETTINGS: '/bills/settings/save/',
  FETCH_SUMMARY: '/bills/summary/',
  APPROVE_BILLS: '/bills/approve/',
  // DELETE
  DELETE_BILL: '/bills/delete/',
  //SCAN_BILLS
  SCAN_BILLS: '/v1.1/api-bills/bills_ocr/',
  GET_SCANNED_BILL_AUDIT_LOGS: '/bills/import/scan_logs/',
  DISMISS_SCANNED_BILL_AUDIT_LOG: '/bills/import/scan_log/',
  BILL_DATA_REVIEWED: '/bills/reviewed/',
  // PERSIST_USER_FILTERS
  BILLS_USER_PERSIST: '/bills/user-persist/',
  // ADJUST COST
  BULK_DOCKET_UPDATE: '/mobile/docket/bulk_update/',
  ACTIVE_BILLS_INTEGRATION: '/integration/active-bill-integration/',
  GET_BILL_AUDIT_LOGS: '/bills/audit_logs/',
  GET_EXTRACTED_NUMBERS: '/v1.1/api-bills/extracted_numbers/',
  GET_LINE_ITEM_SUGGESTIONS: '/v1.1/api-bills/line_item_suggestions/',
  /** Report incorrect OCR / scan extraction for a bill */
  SCAN_ISSUE_CREATE: '/bills/scan-issue/create/',
  /** Tenant-scoped scan issues list — for customers viewing their own issues (requires Tenant-Id header) */
  SCAN_ISSUE_LIST: '/bills/scan-issue/get',
  /** Engineer-only scan issues list — no Tenant-Id header, optional ?tenant_id query param */
  SCAN_ISSUE_ENGINEER_LIST: '/bills/scan-issue/engineer/',
  /** Engineer-only OCR adoption — all clients (tenants) with their OCR provider + per-provider counts */
  SCAN_ISSUE_OCR_ADOPTION: '/bills/scan-issue/ocr-adoption/',
  /** Engineer-only OCR adoption analytics — aggregates for the adoption dashboard */
  SCAN_ISSUE_OCR_ADOPTION_ANALYTICS:
    '/bills/scan-issue/ocr-adoption/analytics/',
  /** Persist OCR schema overrides for a bill document (requires customer tenant-id header) */
  SAVE_BILL_SCHEMA: '/mobile/supplier/save_bill_schema/',
  /** Generate schema overrides via field corrections or a free-text prompt (requires customer tenant-id header) */
  GENERATE_BILL_SCHEMA: '/mobile/supplier/generate_bill_schema/',
  SCAN_ISSUE_ATTACHMENT_SAVE: '/attachment/save_attachment/',
};

/** `/bills/get/{id}/` — same path shape as staging bill detail URLs (id in path, not `?id=`). */
export const getBillGetByIdPath = (id: string): string =>
  `${BILLS_ENDPOINTS.GET_BILL}/${id}/`;

/** POST body includes `message`, `sender_name`, `is_engineer`, `scan_issue_id`. */
export const getScanIssueMessagePath = (scanIssueId: string): string =>
  `/bills/scan-issue/${scanIssueId}/message/`;

/** GET /bills/scan-issue/:id/ — fetch a single scan issue by its ID. */
export const getScanIssuePath = (id: string): string =>
  `/bills/scan-issue/${id}/`;

/** PATCH /bills/scan-issue/:id/status/ — update scan issue status (e.g. reopen with { status: "SUBMITTED" }). */
export const getScanIssueStatusPath = (scanIssueId: string): string =>
  `/bills/scan-issue/${scanIssueId}/status/`;
